import React from "react";
import Button from "../button/button.component";

const Intro = () => {
  const handleEmail = () => {
    window.location.href = "mailto:tarachand122333@gmail.com";
  };

  return (
    <div className="w-full h-full justify-center flex py-16 md:py-20 lg:py-32 px-4 lg:px-0">
      <div className="max-w-6xl flex flex-col gap-3 lg:gap-4">
        <p className="font-bold text-lg text-white">
          We are a software development company.
        </p>
        <div className="flex flex-col gap-10 lg:gap-20">
          <div
            className="flex flex-col gap-4 w-full items-center"
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={1000}
          >
            <h1 className="hidden lg:flex lg:text-6xl text-center font-bold">
              We design and engineer the most user
            </h1>
            <h1 className="hidden lg:flex lg:text-6xl text-center font-bold">
              centric software products
            </h1>
            <h1 className="text-4xl font-medium lg:hidden text-center">
              We design and engineer the most user centric software products
            </h1>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={1500}
          >
            <h1 className="text-xl lg:text-2xl">
              YTC is an AI-powered software development company that builds web,
              mobile, and custom applications with solid engineering
              foundations.
            </h1>
            <h1 className="text-xl lg:text-2xl pt-4">
              Unlike 99% of agency-built software that struggles with poor
              foundations, leading to costly rebuilds and bug-ridden iterations,
              we prioritise creating a rock-solid technical base from the start.
            </h1>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row">
            <Button onClick={handleEmail}>
              Hire us to build your software product
            </Button>
            <Button onClick={handleEmail}>
              Hire our engineers to work with your team
            </Button>
            <a
              href="/how-we-build"
              className="text-white flex items-center justify-center underline pl-4"
            >
              How we build software
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
